import i18n from '@/configs/i18n'
import vi from './vi.json'
import en from './en.json'

// Registers this module's `report_waf` namespace (see configs/i18n).
i18n.addResourceBundle('vi', 'report_waf', vi)
i18n.addResourceBundle('en', 'report_waf', en)
